import './App.css';
import RegistrationForm from './Components/RegistrationForm';

function App() {
  return (
    <div className="App">
      <RegistrationForm/>
    </div>
  );
}

export default App;
